/* global CustomFunctions */

import { mmSetSize as _mmSetSize } from "./mind/setsize";

/**
 * Resizes a formula block: extends formulas into empty cells and clears
 * surplus cells outside the target rectangle.
 *
 * Faithful TypeScript port of the C# Excel-DNA MM_SETSIZE function.
 * See assets/Archive/AM.XLLDistributions/XLLDistributions.cs line 1340.
 *
 * @customfunction SETSIZE
 * @requiresAddress
 * @param nbRows Number of rows for the target block.
 * @param nbCols Number of columns for the target block.
 * @param invocation Custom function handler.
 * @returns {Promise<number>} Always 0; the resize runs asynchronously.
 */
export async function mmSetSize(
  nbRows: number,
  nbCols: number,
  invocation: CustomFunctions.Invocation
): Promise<number> {
  return _mmSetSize(nbRows, nbCols, invocation);
}

CustomFunctions.associate("SETSIZE", mmSetSize);